/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle_tool': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><clipPath id="svgicon_circle_tool_a"><path pid="0" d="M0 0h24v24H0z"/></clipPath></defs><g clip-path="url(#svgicon_circle_tool_a)"><g data-name="Ellipse 2" transform="translate(3 3)" _fill="none" _stroke="#1d1d1d" stroke-linecap="round" stroke-width="2.5"><circle pid="1" cx="9" cy="9" r="9" _stroke="none"/><circle pid="2" cx="9" cy="9" r="7.75"/></g></g>'
  }
})
